import React from 'react';
import { GovFormWeb } from '@gov-design-system-ce/react-form';
import { useTranslationWithNamespace } from '@gov-nx/core/service';
import { useEPeticeEditContext } from '@gov-nx/module/page';
import {
	Button,
	ButtonGroupLayout,
	FormInput,
	FormSelect,
	FormWidthElementLayout,
	LayoutGap,
	optionsToChildren,
} from '@gov-nx/ui/web';

export const PetitionMemberForm = () => {
	const { getLocalizeCurried } = useTranslationWithNamespace();

	const { code, petitionMemberAddressLookup } = useEPeticeEditContext();

	const tsn = getLocalizeCurried(code);
	const isProcessing = petitionMemberAddressLookup.isLoading;

	return (
		<GovFormWeb
			formDefinition={petitionMemberAddressLookup.formDefinition}
			onSubmit={petitionMemberAddressLookup.onSubmit}>
			<FormWidthElementLayout type="l">
				<LayoutGap gap="m">
					<FormInput
						label={{ children: tsn('formular.pole.jmeno') }}
						field={{
							name: 'jmeno',
							isDisabled: isProcessing,
							placeholder: tsn('formular.placeholder.jmeno'),
						}}
					/>

					<FormInput
						label={{ children: tsn('formular.pole.prijmeni') }}
						field={{
							name: 'prijmeni',
							isDisabled: isProcessing,
							placeholder: tsn('formular.placeholder.prijmeni'),
						}}
					/>

					<div className="text-body-m text-neutral-black">
						{tsn('formular.nadpis.vyhledat-adresu')}
					</div>

					<FormInput
						label={{ children: tsn('formular.pole.nazev-obce') }}
						field={{
							name: 'nazevObce',
							isDisabled: isProcessing,
							placeholder: tsn('formular.placeholder.nazev-obce'),
						}}
					/>

					<FormInput
						label={{ children: tsn('formular.pole.nazev-ulice') }}
						field={{
							name: 'nazevUlice',
							isDisabled: isProcessing,
							placeholder: tsn('formular.placeholder.nazev-ulice'),
						}}
					/>

					<FormInput
						label={{ children: tsn('formular.pole.cislo') }}
						field={{
							name: 'cislo',
							isDisabled: isProcessing,
							placeholder: tsn('formular.placeholder.cislo'),
						}}
					/>

					<Button
						color="primary"
						type="outlined"
						size="s"
						isDisabled={petitionMemberAddressLookup.isLoading}
						isLoading={petitionMemberAddressLookup.isLoading}
						onClick={() => petitionMemberAddressLookup.onLookup()}
						aria-label={tsn('akce.wcag.hledat')}>
						{tsn('formular.tlacitko.hledat')}
					</Button>

					{!!petitionMemberAddressLookup.options.length && (
						<FormSelect
							field={{
								name: '_address',
								isDisabled: isProcessing,
								children: optionsToChildren(
									petitionMemberAddressLookup.options
								),
							}}
							label={{
								children: tsn('formular.pole.clen-adresa'),
							}}
						/>
					)}
				</LayoutGap>
			</FormWidthElementLayout>

			<ButtonGroupLayout customClasses="mt-(--spacing-m)!">
				<Button
					nativeType="submit"
					aria-label={tsn('akce.wcag.pridat-clena')}
					isDisabled={petitionMemberAddressLookup.disableSubmitButton}
					color="primary"
					type="solid">
					{tsn('formular.tlacitko.pridat-clena')}
				</Button>
			</ButtonGroupLayout>
		</GovFormWeb>
	);
};
